module.exports = __webpack_public_path__ + "img/windows.53d1888b.gif";